import clsx from "clsx";
import React, { useEffect, useState, useRef } from "react";
import { useCurrentDevice } from "../hooks";
import { AddMessageToChatRequest } from "../api-generated";

interface OpenAiChatFormProps {
  messageDraftStarter?: string;
  onSubmit: (data: AddMessageToChatRequest) => void;
  isSubmitting: boolean;
  isDisabled?: boolean;
  onOpenModal: () => void;
  shouldTranslateMessageToDe: boolean;
  turnOnMultiSelect: () => void;
}

const OpenAiChatForm: React.FC<OpenAiChatFormProps> = ({
  messageDraftStarter,
  onSubmit,
  isDisabled = false,
  onOpenModal,
  shouldTranslateMessageToDe,
  turnOnMultiSelect,
  isSubmitting,
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const { isPhone, isComp } = useCurrentDevice();

  const [messageDraft, setMessageDraft] = useState<string>(
    messageDraftStarter || ""
  );

  useEffect(
    () => setMessageDraft(messageDraftStarter || ""),
    [messageDraftStarter]
  );

  useEffect(() => {
    if (isSubmitting) {
      setMessageDraft("");
    }
  }, [isSubmitting]);

  const submit = () => {
    onSubmit({
      userMessage: messageDraft,
      shouldTranslateToGerman: shouldTranslateMessageToDe,
    });
  };

  const isDisabledOrEmpty = isDisabled || messageDraft.trim().length === 0;

  const handleSubmit = (
    event?: React.FormEvent<HTMLFormElement>,
    isClick?: boolean
  ) => {
    //TODO: this is fucked
    if (event) {
      event.preventDefault();
    }
    if (isDisabledOrEmpty) {
      return;
    }

    if (isClick) {
      submit();
    }
  };

  function handleTextareaKeyDown(
    event: React.KeyboardEvent<HTMLTextAreaElement>
  ) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  }

  return (
    <form ref={formRef} onSubmit={handleSubmit}>
      <div className="flex justify-between h-48 p-2 gap-2">
        <div
          className={clsx([
            "h-full",
            { "w-3/4": isPhone, "w-[80%]": !isPhone },
          ])}
        >
          <textarea
            onKeyDown={handleTextareaKeyDown}
            className="w-full h-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
            value={messageDraft}
            onChange={(event) => setMessageDraft(event.target.value)}
          />
        </div>

        <div
          className={clsx([
            "h-full flex justify-center gap-4 flex-col",
            { "w-[20%]": !isPhone, "w-1/4": isPhone, "fle-col": !isComp },
          ])}
        >
          <div className={clsx(["flex justify-center", { "h-1/3": !isComp }])}>
            <button
              onClick={() => {
                handleSubmit(undefined, true);
              }}
              type="submit"
              className={clsx([
                "font-bold text-white bg-blue-500 rounded w-full align-middle disabled:opacity-50",
                {
                  "p-4": isComp,
                  //why do I have to manually specify to only do this if not disabled?
                  "active:bg-blue-800": !isDisabledOrEmpty,
                },
              ])}
              disabled={isDisabledOrEmpty}
            >
              Send
            </button>
          </div>

          <div className={clsx(["flex justify-center", { "h-1/3": !isComp }])}>
            <button
              onClick={turnOnMultiSelect}
              type="button"
              className={clsx([
                "font-bold text-white bg-blue-500 rounded active:bg-blue-800 w-full align-middle",
                { "p-4": isComp },
              ])}
            >
              Multi select
            </button>
          </div>

          <button onClick={onOpenModal}>
            <div className="flex text-sm justify-center text-gray-800 hover:underline">
              Settings
            </div>
          </button>
        </div>
      </div>
    </form>
  );
};

export default OpenAiChatForm;
